import React, { useEffect, useState } from "react"; 
import RenderPaymentMethod from "./RenderPaymentMethod"; 
import { PaymentMethodReferenceInPurchases, RelatedPaymentMethodGridModel } from "../models";
import { AuthService, PaymentMethodService } from "../services";
import { InvoicePopupWrapper } from "../styles";
import { CustomLabel, FlexContainer, Loader, ModalComponent, RedButton, ToastService, UtilityMethods } from "@mindmemobile/mm-shared-global";

type Props = {
  onClose: (deleted: boolean) => void;
  paymentMethod: RelatedPaymentMethodGridModel;
};
const DeletePaymentMethodPopUp: React.FC<Props> = ({
  paymentMethod,
  onClose,
}) => {
  const [popupData, setPopUpData] =
    useState<PaymentMethodReferenceInPurchases | null>(null);
  const [showLoader, setLoader] = useState<boolean>(true);
  useEffect(() => {
    PaymentMethodService.getPaymentMethodReferenceInPurchases(
      AuthService.authData.accountId,
      paymentMethod.id
    ).subscribe({
      next: (response) => {
        if (!response.result) {
          console.log("Error");
        } else {
          const deserializedData =
            PaymentMethodReferenceInPurchases.deserializeAPIModel(
              response.result
            );
          setPopUpData(deserializedData);
          setLoader(false);
        }
      },
    });
  }, []);

  const onClickDelete = () => {
    PaymentMethodService.deletePaymentMethod(
      AuthService.authData.accountId,
      paymentMethod?.id
    ).subscribe({
      next: (result) => {
        if (result.result.success) {
          ToastService.showSuccess(`Payment Method deleted successfully`);
          onClose(true);
        } else {
          ToastService.showError(`Error in deleting Payment Method`);
        }
      },
    });
  };

  const renderDeletePopUpContent = () => {
    return (
      <InvoicePopupWrapper className="cancel-payment-popup">
        <CustomLabel
          textAlign="center"
          className="full-width"
          fontSize={"18px"}
          margin="20px 0px 30px"
        >
          Do you want to{" "}
          <span className="red-text semi-bold">permanently delete</span> this
          payment method?
        </CustomLabel>
        <FlexContainer spacing={30} margin="15px">
          <CustomLabel>Payment Method</CustomLabel>
          <RenderPaymentMethod paymentMethod={popupData?.paymentMethod} />
          <CustomLabel>{paymentMethod?.isPrimary ? "Primary" : ""}</CustomLabel>
        </FlexContainer>
        <FlexContainer spacing={30} margin="15px">
          <CustomLabel>Subscriptions</CustomLabel>
          <CustomLabel>{popupData?.subscriptions}</CustomLabel>
        </FlexContainer>
        <FlexContainer spacing={30} margin="15px">
          <CustomLabel>Scheduled Invoices</CustomLabel>
          <CustomLabel>{popupData?.scheduledInvoices}</CustomLabel>
        </FlexContainer>
        <FlexContainer spacing={30} margin="15px">
          <CustomLabel>Total Paid</CustomLabel>
          <CustomLabel>{popupData?.totalPaidAmount}</CustomLabel>
        </FlexContainer>
        <FlexContainer spacing={30} margin="15px">
          <CustomLabel>Last Used</CustomLabel>
          <CustomLabel>
            {!popupData?.lastUsed
              ? "Never"
              : UtilityMethods.formatDateInString(popupData?.lastUsed)}
          </CustomLabel>
        </FlexContainer>
        {paymentMethod.isPrimary && (
          <CustomLabel color="red">
            Deleting a Payment Method will set an alternate Payment Method to
            Primary
          </CustomLabel>
        )}
      </InvoicePopupWrapper>
    );
  };
  return (
    <ModalComponent
      title="Delete Payment Method"
      titleFontSize="22px"
      bodyPadding="40px 45px"
      showFooter={true}
      minHeight="240px"
      wrapperWidth="630px"
      bodyBackgroundColor="#fff"
      footerBackground="rgba(255, 0, 0, 0.1)"
      redHeader={true}
      blueHeader={false}
      footerHeight="auto"
      onClose={() => onClose(false)}
      footerContent={
        <FlexContainer alignItems="center" justifyContent="center" spacing={15}>
          <RedButton
            minWidth="120px"
            height="30px"
            onClick={() => onClickDelete()}
          >
            Delete
          </RedButton>
          <RedButton
            primary
            minWidth="120px"
            height="30px"
            onClick={() => onClose(false)}
          >
            Do Not Delete
          </RedButton>
        </FlexContainer>
      }
    >
      {showLoader
        ? new Loader(true).loaderComponent
        : renderDeletePopUpContent()}
    </ModalComponent>
  );
};

export default DeletePaymentMethodPopUp;
